export const environment = {
  production: true,
  loginHost: 'https://login.x-keeper.net',
  staticUrl: 'https://static.x-keeper.net',
  downloadFilesUrl: '/download-files',
  apiUrl: '/api',
  api2Url: '/api2',
  xOutkeepSentryDsn:
    'https://45d62c890687d89a8fa264152ac91d71@sentry.stage.x-keeper.net/11',
  xOutkeepInfrastructureEnv: 'production',
  xOutkeepEnableLanguageChange: false,
  workflowsEnabled: false,
  warehouseIframeUrl: 'https://system.x-keeper.net/p/warehouse',
  accountingIframeUrl: 'https://system.x-keeper.net/p/accounting',
  docflowIframeUrl: 'https://system.x-keeper.net/logistic/?embed=1#/docFlow',
};
